import React from 'react';

const formatDistance = (distanceKm) => {
  if (!Number.isFinite(distanceKm)) return '—';
  if (distanceKm < 1) return `${(distanceKm * 1000).toFixed(0)} m`;
  if (distanceKm < 100) return `${distanceKm.toFixed(1)} km`;
  return `${Math.round(distanceKm)} km`;
};

const EarthResultsPanel = ({
  guesses,
  maxAttempts,
  status,
}) => {
  const latest = guesses.length > 0 ? guesses[guesses.length - 1] : null;

  return (
    <div className="earth-results-panel">
      <div className="earth-results-header">
        <h3>Results</h3>
        <span className="earth-results-attempts">
          {guesses.length}/{maxAttempts} attempts
        </span>
      </div>

      {latest ? (
        <div className="earth-latest-feedback">
          <div className="earth-accuracy-line">
            You are <strong>{latest.accuracyPct}%</strong> correct
          </div>
          <div className="earth-distance-line">
            Distance from answer: <strong>{formatDistance(latest.distanceKm)}</strong>
          </div>
        </div>
      ) : (
        <p className="earth-empty-feedback">
          Drop a pin on the map to make your first guess.
        </p>
      )}

      {guesses.length > 0 && (
        <div className="earth-history-list">
          {[...guesses]
            .slice()
            .reverse()
            .map((guess) => (
              <div key={`earth-attempt-${guess.attemptNumber}`} className="earth-history-row">
                <span>Attempt {guess.attemptNumber}</span>
                <span>{formatDistance(guess.distanceKm)}</span>
                <span>{guess.accuracyPct}%</span>
                <span>{guess.isCorrect ? 'Correct' : status === 'active' ? 'Miss' : 'Final'}</span>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(EarthResultsPanel);
